var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDepartamentCard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Grupo_12856",
    width: 30.48,
    height: 35.585,
    viewBox: "0 0 30.48 35.585",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:#09c}.cls-2{fill:#272727}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11856",
    transform: "translate(10.637 27.707)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rect\\xE1ngulo_4578",
    d: "M0 0H9.397V7.108H0z",
    className: "cls-1"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11857",
    transform: "translate(0 34.815)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_25983",
    d: "M501.742 913.561h-29.38c-.295.007-.541-.16-.551-.372s.221-.39.516-.4h29.414c.294-.007.541.16.55.372s-.221.39-.515.4z",
    className: "cls-2",
    transform: "translate(-471.812 -912.791)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11861",
    transform: "translate(5.945 4.199)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11858"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rect\\xE1ngulo_4579",
    d: "M0 0H5.441V4.315H0z",
    className: "cls-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11859",
    transform: "translate(6.669)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rect\\xE1ngulo_4580",
    d: "M0 0H5.441V4.315H0z",
    className: "cls-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11860",
    transform: "translate(13.339)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rect\\xE1ngulo_4581",
    d: "M0 0H5.441V4.315H0z",
    className: "cls-1"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11865",
    transform: "translate(5.945 9.361)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11862"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rect\\xE1ngulo_4582",
    d: "M0 0H5.441V4.315H0z",
    className: "cls-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11863",
    transform: "translate(6.669)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rect\\xE1ngulo_4583",
    d: "M0 0H5.441V4.315H0z",
    className: "cls-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11864",
    transform: "translate(13.339)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rect\\xE1ngulo_4584",
    d: "M0 0H5.441V4.315H0z",
    className: "cls-1"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11869",
    transform: "translate(5.945 14.673)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11866"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rect\\xE1ngulo_4585",
    d: "M0 0H5.441V4.315H0z",
    className: "cls-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11867",
    transform: "translate(6.669)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rect\\xE1ngulo_4586",
    d: "M0 0H5.441V4.315H0z",
    className: "cls-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11868",
    transform: "translate(13.339)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rect\\xE1ngulo_4587",
    d: "M0 0H5.441V4.315H0z",
    className: "cls-1"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11873",
    transform: "translate(5.945 20.053)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11870"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rect\\xE1ngulo_4588",
    d: "M0 0H5.441V4.315H0z",
    className: "cls-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11871",
    transform: "translate(6.669)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rect\\xE1ngulo_4589",
    d: "M0 0H5.441V4.315H0z",
    className: "cls-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11872",
    transform: "translate(13.339)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rect\\xE1ngulo_4590",
    d: "M0 0H5.441V4.315H0z",
    className: "cls-1"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11874",
    transform: "translate(3.503)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_25984",
    d: "M500.032 903.1h-23.664v-35.588h23.664zm-22.895-.769h22.126v-34.05h-22.126z",
    className: "cls-2",
    transform: "translate(-476.368 -867.512)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDepartamentCard);
export default __webpack_public_path__ + "static/media/departament-card.9b8fc1ffc270882f1d25f69e5a11c9bd.svg";
export { ForwardRef as ReactComponent };